// extracted by mini-css-extract-plugin
export var richText = "styles-module--richText--zkJhu";
export var largeText = "styles-module--largeText--HG-ig";